import { useMutation } from "@apollo/client";
import { ADD_TRIP, LIST_TRIP_PUBLICATION_OPERATION } from "../graphQl/TripPublicationAPI";

const withAuthorization = (accessToken) => ({
  headers: {
    authorization: accessToken ? `Bearer ${accessToken}` : "",
  },
});

export const useAddTrip = (accessToken = "") => {
  // Relance la liste des circuits si elle est montée au moment de la création
  // (sinon elle est revalidée au montage, cf. useListTripPublication).
  const [createTripMutation, { loading, error }] = useMutation(ADD_TRIP, {
    refetchQueries: [LIST_TRIP_PUBLICATION_OPERATION],
  });

  const addTrip = async (tripInput) => {
    const res = await createTripMutation({
      variables: { tripInput },
      context: withAuthorization(accessToken),
    });

    return {
      data: res.data?.MT_ADD_TRIP?.data || null,
      error: res.data?.MT_ADD_TRIP?.error || null,
    };
  };

  return {
    addTrip,
    loading,
    error,
  };
};
